import { FitEconomizeProps } from '.';
import FitText from '../FitText';

export default function FitEconomizeSecondary({
  width = 0,
  height = 0,
  matrix = [0, 0, 0, 0, 0, 0, 0],
  text,
  top = 0,
  left = 0,
  right,
  color = [0, 0, 0],
  textAlign = 'center',
  whiteSpace = 'normal',
  background: [r, g, b, a] = [0, 0, 0, 0],
  rotate = 0,
  fontFamily = '"Primary"',
  fontWeight = 'normal',
  borderRadius,
  alignItems,
  justifyContent,
}: FitEconomizeProps) {
  const isRight = right !== undefined ? true : false;
  return (
    <div
      style={{
        transition: 'transform 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          transition: 'height 500ms, top 500ms, left 500ms, right 500ms',
          transformOrigin: '0 50%',
          transform: `rotate(-${rotate}rad)`,
          top,
          ...(() => (isRight ? { right: right } : { left: left }))(),
          fontFamily,
          fontWeight,
          letterSpacing: '0.1px',
          height,
          width,
          textAlign,
          whiteSpace,
          background: `rgb(${r}, ${g}, ${b}, ${a})`,
          alignItems,
          justifyContent,
          borderRadius: `${borderRadius}pt`,
        }}
      >
        <FitText
          {...{
            text: 'ECONOMIZE',
            fontFamily,
            fontWeight,
            color,
            width: 0.75 * width,
            height: 0.4 * height,
            left: 0.125 * width,
            alignItems,
            justifyContent,
            top: 0.05 * height,
          }}
        />
        <FitText
          {...{
            text,
            fontFamily,
            fontWeight,
            color,
            width: 0.7 * width,
            height: 0.65 * height,
            left: 0.15 * width,
            top: 0.3 * height,
            alignItems,
            justifyContent,
          }}
        />
      </div>
    </div>
  );
}
